import { EnglishAccentType } from "../../ruleSets/accentRules";
import { AllRules } from "../../ruleSets/allRules";
import { Say } from "../widgets/Say";
import { join, accentColors } from "./constants";

/** <S accent='Accent'>word</S> converts the word into IPA for the accent, colored according to the accent */
export function SayAccentPhones(props: {
  accent: EnglishAccentType,
  children: string,
  vowelColor?: string,
}) {
  const { afterRules } = AllRules.get().convert(props.children, 'English', props.accent);
  const text = `/${join}${afterRules}${join}/`.replace(/ˈ/g, `${join}ˈ${join}`);
  const say = `/${afterRules}/`;

  const textColor = props.vowelColor ?? accentColors[props.accent];

  return <Say accent={props.accent} say={say} textColor={textColor}>{text}</Say>
}
